module.exports = __webpack_public_path__ + "static/media/dashboard-character.9ff186e0.svg";